<ion-content>

  <ion-list>

    <ion-button class="style-logOut ion-hide-sm-up" fill="clear" Expand="full" (click)="onClickAdd()">
      <span><ion-icon name="add" class="style-icon"></ion-icon>
        {{getAddButtonText()}}
      </span>
    </ion-button>

    <!-- <ion-button class="style-logOut" fill="clear" Expand="full" (click)="onClickUser()">
      <span>
        <ion-icon name="pencil" class="style-icon"></ion-icon>
        Account</span>
    </ion-button>

    <ion-button class="style-logOut" fill="clear" Expand="full" (click)="logoutFx()">
      <span><ion-icon name="exit" class="style-icon"></ion-icon>
        Log out</span>
    </ion-button> -->

  </ion-list>

</ion-content>